import styled from '@emotion/styled';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const AccordionExpandMoreIcon = styled(ExpandMoreIcon)(() => ({
  '.MuiAccordionSummary-content.Mui-expanded &': {
    transform: 'rotate(180deg)'
  }
}));
